module.exports = __webpack_public_path__ + "img/pay-logo-union.a9adeeb1.png";